import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { api } from '@/utils/api';
import { ApiErrorResponse, ApiResponse } from '@/types/api';
import { Nullable } from '@/types/helper';

interface GetClientFileListRequest {
  fileId: Nullable<number>;
}

interface GetClientFileListResponse {
  clients: {
    id: number;
    name: Nullable<string>;
    email: Nullable<string>;
    company: Nullable<string>;
    phone: Nullable<string>;
    isSelected: boolean;
  }[];
}

export const getClientFileList = ({ fileId }: GetClientFileListRequest) => {
  return api.get<ApiResponse<GetClientFileListResponse>>(`/client/file/list`, {
    params: {
      fileId: fileId ?? undefined,
    },
  });
};

const useClientFileList = <
  TData = AxiosResponse<ApiResponse<GetClientFileListResponse>>,
  TError = AxiosError<ApiErrorResponse>,
>(
  request: GetClientFileListRequest,
  options?: UseQueryOptions<
    AxiosResponse<ApiResponse<GetClientFileListResponse>>,
    TError,
    TData,
    ['getClientFileList', GetClientFileListRequest]
  >,
): UseQueryResult<TData, TError> => {
  return useQuery(
    ['getClientFileList', request],
    () => getClientFileList(request),
    {
      ...options,
    },
  );
};

export default useClientFileList;
